var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoresIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7l-3.767-.753 2.131-3.196-1.414-1.414-3.196 2.131L9.001.001h-2l-.753 3.767-3.196-2.131-1.414 1.414 2.131 3.196L.002 7v2l3.767.753-2.131 3.196 1.414 1.414 3.196-2.131.753 3.767h2l.753-3.767 3.196 2.131 1.414-1.414-2.131-3.196L16 9V7zm-8 4a3 3 0 110-6 3 3 0 010 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8a1 1 0 11-2 0 1 1 0 012 0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoresIcon);
export default __webpack_public_path__ + "static/media/cores-icon.0f65211044d55440a4200f79a62effdc.svg";
export { ForwardRef as ReactComponent };